module.exports = ".icon-beneficios img {\n  max-height: 40px; }\n\n.icon-beneficios + p {\n  padding-top: 20px; }\n"